import { UserButton } from "@clerk/react";
import { Clock } from "lucide-react";

export default function Pending({ error }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F6F4EE] p-6">
      <div className="panel max-w-lg w-full p-10 fade-up" data-testid="pending-access">
        <div className="flex items-center justify-between">
          <Clock className="h-6 w-6 text-amber-600" strokeWidth={1.5} />
          <UserButton />
        </div>
        <h1 className="font-serif text-4xl tracking-tight mt-6">
          {error ? "We couldn't load your account" : "Awaiting access"}
        </h1>
        <p className="text-slate-600 mt-4 leading-relaxed">
          {error
            ? "Please refresh the page. If this keeps happening, contact your firm administrator."
            : "Your sign-in worked, but you haven't been added to a firm yet. Ask your firm administrator to invite this email address, then refresh this page."}
        </p>
      </div>
    </div>
  );
}
